import { render, staticRenderFns } from "./workIncome-new.vue?vue&type=template&id=2c42013f&scoped=true&"
import script from "./workIncome-new.vue?vue&type=script&lang=js&"
export * from "./workIncome-new.vue?vue&type=script&lang=js&"
import style0 from "./workIncome-new.vue?vue&type=style&index=0&id=2c42013f&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c42013f",
  null
  
)

export default component.exports